import type { VatAlerts } from '../api/vat';
import { formatMoney } from '../format';

// Göstərici və ƏDV xəbərdarlıqları (KT-59, KT-66); ana səhifə KT-99-da Home.tsx-dədir.
export function Kpi({ label, value, strong = false, hint }: { label: string; value: number; strong?: boolean; hint?: string }) {
  return (
    <div className="kpi">
      <span className="muted small">{label}</span>
      <strong className={strong ? 'kpi-strong' : undefined}>{formatMoney(value)}</strong>
      {hint && <span className="muted small">{hint}</span>}
    </div>
  );
}

const VAT_NAME: Record<string, string> = { vat18: '18%', vat0: '0%', exempt: 'azad', agri: 'k/t (ticarət əlavəsi)' };

/** ƏDV xəbərdarlıqları (KT-66): rejimin bitməsi, qiymətsiz qəbul, açıq tapşırıqlar, 12 aylıq hədd. */
export function VatAlertList({ alerts }: { alerts: VatAlerts }) {
  const items: { key: string; text: string; cls: string }[] = [];
  for (const r of alerts.regimes) {
    items.push({
      key: `r-${r.code}`,
      cls: r.active ? 'vat-warn' : 'vat-over',
      text: r.active
        ? `ƏDV rejimi «${VAT_NAME[r.code]}» ${r.endsOn}-də bitir. Qanun uzadılmasa, mallar 18%-ə keçirilməlidir (avtomatik dəyişmir).`
        : `ƏDV rejimi «${VAT_NAME[r.code]}» ${r.endsOn}-də bitib — malları 18%-ə keçirin və ya qanunun uzadılmasını yoxlayın.`,
    });
  }
  if (alerts.unpriced.count > 0) {
    items.push({ key: 'u', cls: 'vat-warn', text: `Qiymətsiz qəbul var: ${alerts.unpriced.count} sənəd, ${alerts.unpriced.qty} vahid. Maya hesabına təsir edir — orta maya müvəqqəti aşağıdır.` });
  }
  if (alerts.openTasks > 0) {
    items.push({ key: 't', cls: 'vat-warn', text: `ƏDV: ${alerts.openTasks} «mayaya köçür» tapşırığı mühasibi gözləyir.` });
  }
  const t = alerts.threshold;
  if (t && t.level !== 'ok') {
    items.push({
      key: 'h',
      cls: t.level === 'over' ? 'vat-over' : 'vat-warn',
      text:
        t.level === 'over'
          ? `12 aylıq vergi tutulan dövriyyə ${formatMoney(t.turnover)} — ${formatMoney(t.overAt)} həddini keçib: növbəti ayın 10-dək ƏDV qeydiyyatı ərizəsi.`
          : `12 aylıq vergi tutulan dövriyyə ${formatMoney(t.turnover)} — ƏDV həddinə (${formatMoney(t.overAt)}) yaxınlaşır.`,
    });
  }
  if (items.length === 0) return null;
  return (
    <div className="vat-notice card" role="status">
      {items.map((i) => (
        <p key={i.key} className={`small ${i.cls}`}>
          {i.text}
        </p>
      ))}
    </div>
  );
}
